// extracted by mini-css-extract-plugin
module.exports = {"title":"PageNotFound-module--title--u8dKE","regular":"PageNotFound-module--regular--2xdUH"};